import Dictionary from '../interfaces/dictionary';

const Periodicity: Dictionary[] = [
  { key: 'daily', value: 'Diária' },
  { key: 'weekly', value: 'Semanal' }
];

export { Periodicity as default };
